export default __webpack_public_path__ + "static/Biases_w-4c0076c19384c31a54d55ab56fd17a65.webp";